export default __webpack_public_path__ + "static/media/services (1).2cc1cd22.jpg";